import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { ProblemSection } from '../components/ProblemSection';
import { FailedMethodsSection } from '../components/FailedMethodsSection';
import { AchievementsSection } from '../components/AchievementsSection';
import { StepsSection } from '../components/StepsSection';
import { DifferenceSection } from '../components/DifferenceSection';
import { PricingSection } from '../components/PricingSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { FinalCTASection } from '../components/FinalCTASection';
import { Footer } from '../components/Footer';
function Divider() {
  return <div className="w-full h-px bg-gradient-to-r from-transparent via-gold/30 to-transparent" data-id="element-288"></div>;
}
export function LandingPage() {
  return <main className="min-h-screen bg-navy-900 text-gray-200 font-sans selection:bg-gold selection:text-navy-900" data-id="element-289">
      <HeroSection data-id="element-290" />
      <Divider data-id="element-291" />
      <ProblemSection data-id="element-292" />
      <Divider data-id="element-293" />
      <FailedMethodsSection data-id="element-294" />
      <Divider data-id="element-295" />
      <AchievementsSection data-id="element-296" />
      <Divider data-id="element-297" />
      <StepsSection data-id="element-298" />
      <Divider data-id="element-299" />
      <DifferenceSection data-id="element-300" />
      <Divider data-id="element-301" />
      <PricingSection data-id="element-302" />
      <Divider data-id="element-303" />
      <GuaranteeSection data-id="element-304" />
      <Divider data-id="element-305" />
      <FinalCTASection data-id="element-306" />
      <Footer data-id="element-307" />
    </main>;
}